import { useEffect, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";

const Card = ({ product }) => {
  const [showMore, setShowMore] = useState(false);

  const navigate = useNavigate();

  const {
    _id,
    // _id,
    name,
    brand,
    category,
    description,
    images,
    price,
    discount = 5,
    rating,
    reviews,
    specification,
  } = product;
  // console.log(product);

  const id = product._id;

  // console.log(id);

  const deleteProductHandler = () => {
    // dispatch(deleteProduct(id));
    // console.log(`${id} delete item`);
    // getAllProducts();
  };

  const editButtonHandler = () => {
    // getProductDetails(id);
    navigate(`/edit-product/${id}`);
  };

  return (
    <>
      <div className="bg-white rounded-lg shadow-md max-w-[280px] m-5 overflow-hidden">
        <div className="relative h-[380px] overflow-hidden flex items-center">
          <div className=" absolute right-0 top-0 bg-gray-200 text-slate-700  w-fit px-2 py-2 rounded  flex justify-center items-center cursor-pointer opacity-30 hover:opacity-100">
            <div>
              <MdDelete
                onClick={deleteProductHandler}
                className="inline-block mx-2 hover:text-red-500"
              />
            </div>
            <button onClick={editButtonHandler}>
              <FaRegEdit className="inline-block hover:text-green-400" />
            </button>
          </div>
          <img src={`${images[0].url}`} alt={name} className="" />
        </div>
        {/* <hr className="text-slate-500 " style={{ color: "red" }} /> */}

        <div className="p-4">
          <div className="flex justify-between items-center mt-2">
            <div className="flex items-center">
              <span className="text-xl font-medium">
                ৳{(price - (price * discount) / 100).toFixed(2)}
              </span>
              {discount > 0 && (
                <span className="text-sm text-Light ml-2 line-through">
                  ৳{price.toFixed(2)}
                </span>
              )}
            </div>
            <div className="flex items-center">
              <span className="text-sm text-yellow-500">
                {rating} ({reviews.length} reviews)
              </span>
            </div>
          </div>
          <div>
            <div className="w-full flex-none text-sm font-medium text-green-600 my-2">
              In stock
            </div>
          </div>
          <Link
            to={`/admin/products/${_id}`}
            className="font-medium text-slate-900 hover:underline line-clamp-2"
          >
            {name}
          </Link>
          <p className="text-base text-Light">
            {brand} - {category}
          </p>

          {/* {showMore ? (
            <>
              <p className="text-base mt-2">{description}</p>
           
              <ul className="mt-2">
                {specification.map((spec, index) => (
                  <li key={index} className="text-base text-Light ">
                    <span className="font-bold">{spec.name}</span> :{" "}
                    {spec.value}
                  </li>
                ))}
              </ul>
            </>
          ) : (
            description.slice(0, 100) + "..."
          )}
          <button onClick={() => setShowMore(!showMore)} className="block">
            {showMore ? "See Less" : "  See More"}
          </button> */}
        </div>
      </div>
    </>
  );
};

export default Card;
